import * as yup from "yup";

export const useFatherValidation = () => {
  return yup.object({
    amka: yup.string().required("Το πεδίο ΑΜΚΑ είναι υποχρεωτικό"),
    ama: yup.string().required("Το πεδίο Α.Μ.ΟΓΑ/ΕΦΚΑ είναι υποχρεωτικό"),
  });
};
